// api.ts
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT, // or import.meta.env.VITE_API_ENDPOINT
  timeout: 10000,
});

// 每次請求前讀 token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 改善錯誤輸出
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response) {
      console.error('[API ERROR]', error.response.status, error.response.data);
    } else if (error.request) {
      console.error('[API NO RESPONSE]', error.message, error.toJSON?.());
    } else {
      console.error('[API SETUP ERROR]', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
